import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldTargetUser = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'login-form-username',
    defaultMessage: 'Username or email'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'targetUser'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldTargetUser;
